import { GET_SKY_OBJECTS, SAVE_SKY_OBJECT } from '../actions.type'
import { SET_SKY_OBJECTS } from '../mutations.type'
import SkyService from '@/services/SkyService'

const state = {
  location: [],
  evse: [],
  pricePlan: [],
  subscriptionPlan: [],
}

const getters = {
  // chargers: state => state.chargers.map(id => state.chargerData[id])
}

const actions = {
  [GET_SKY_OBJECTS]: ({ commit }, type) => {
    return new Promise((resolve, reject) => {
      const typeCamel = type.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
      SkyService.getSkyObjects(type)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else {
              commit(SET_SKY_OBJECTS, {
                data: response.data,
                type: typeCamel
              })
              resolve()
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [SAVE_SKY_OBJECT]: (undefined, { type, data }) => {
    return SkyService.saveSkyObject(type, data)
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_SKY_OBJECTS]: (state, { data, type }) => {
    state[type] = data
    // if (type === 'location') state.location = data
    // data.forEach(charger => {
    //   state.chargerData[charger.id] = charger
    // });
    // state.chargers = Object.keys(state.chargerData)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
